// Este método está copiado del proyecto original de FileSaver https://github.com/eligrey/FileSaver.js/blob/master/src/FileSaver.js#L58
export default function click(node: HTMLElement) {
	try {
		node.dispatchEvent(new MouseEvent('click'));
	} catch {
		const evt = document.createEvent('MouseEvents');
		evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		node.dispatchEvent(evt);
	}
}